// eslint-disable-next-line import/no-unresolved
import nativeBus from '@king/nativeBus';
import { CLOSE_EVENT } from '../constants';

export const handleOnClickCloseButton = (): void => {
  nativeBus.postMessage(CLOSE_EVENT);
};
